var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    transform: "translate(0.533203)",
    fill: "#FF5C00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55588 5.75698L7.79188 3.66011V9.39823C7.79188 9.58065 7.86918 9.7556 8.00677 9.88459C8.14436 10.0136 8.33097 10.086 8.52555 10.086C8.72013 10.086 8.90674 10.0136 9.04433 9.88459C9.18192 9.7556 9.25922 9.58065 9.25922 9.39823V3.66073L11.4959 5.75698C11.5637 5.82114 11.6445 5.87206 11.7335 5.90681C11.8224 5.94156 11.9178 5.95945 12.0142 5.95945C12.1106 5.95945 12.206 5.94156 12.295 5.90681C12.3839 5.87206 12.4647 5.82114 12.5325 5.75698C12.6007 5.69314 12.6547 5.61734 12.6916 5.5339C12.7285 5.45047 12.7475 5.36104 12.7475 5.27073C12.7475 5.18042 12.7285 5.091 12.6916 5.00756C12.6547 4.92413 12.6007 4.84833 12.5325 4.78448L9.04388 1.51386C8.90603 1.38566 8.71972 1.31372 8.52555 1.31372C8.33138 1.31372 8.14507 1.38566 8.00722 1.51386L4.51855 4.78448C4.38922 4.91498 4.3189 5.08741 4.32239 5.26551C4.32588 5.4436 4.4029 5.6135 4.53725 5.73945C4.6716 5.86541 4.85282 5.93761 5.04279 5.94088C5.23277 5.94415 5.41669 5.87823 5.55588 5.75698",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1206 8.18324C13.7159 8.18324 13.3866 8.49137 13.3866 8.87074V11.5001C13.3866 11.9482 12.9979 12.3126 12.5206 12.3126H4.5306C4.0526 12.3126 3.66393 11.9482 3.66393 11.5001V8.87012C3.66393 8.68778 3.58667 8.51291 3.44914 8.38398C3.31162 8.25505 3.12509 8.18262 2.9306 8.18262C2.73611 8.18262 2.54958 8.25505 2.41205 8.38398C2.27453 8.51291 2.19727 8.68778 2.19727 8.87012V11.5001C2.19727 12.7064 3.24393 13.6876 4.5306 13.6876H12.5206C13.8066 13.6876 14.8539 12.7064 14.8539 11.5001V8.87012C14.8539 8.68778 14.7767 8.51291 14.6391 8.38398C14.5016 8.25505 14.3151 8.18262 14.1206 8.18262",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadArrow);
export default __webpack_public_path__ + "static/media/upload_arrow.d9b7b8a32bb4fecf31e68d9470a0d89f.svg";
export { ForwardRef as ReactComponent };